<template>
  <div class="paper">
    <Header></Header>
    <div class="detail-wrapper">
      <div class="container" style="padding-top: 70px;">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem to="/">
          <Icon type="ios-home"></Icon>首页
        </BreadcrumbItem>
        <BreadcrumbItem>学习中心</BreadcrumbItem>
        <BreadcrumbItem>{{ categoryInfo.title }}</BreadcrumbItem>
        <BreadcrumbItem>{{questionType.title}}</BreadcrumbItem>
      </Breadcrumb>

      <div class="practice-header">
        <div class="practice-title">
          <h1>{{ progressInfo.title }}</h1>
          <!-- <div class="practice-title-note">
            <span v-if="progressInfo.LastPracDatetime">上次做题时间：{{ progressInfo.LastPracDatetime }}</span>
            <span v-else>从未做过</span>
            <span v-show="progressInfo.LastPracDatetime" style="margin-left: 30px">上次正确率：{{ lastRightPercent }}%</span>
          </div> -->
        </div>
        <div class="practice-progress">
          <span class="practice-progress-text">共 {{ exerciseList.length }} 道题</span>
          <div class="practice-progress-bar">
            <Progress :percent="progressPercent" />
          </div>
        </div>
      </div>

      <div class="practice-container clearfix">
        <div class="fl practice-main">
          <div class="practice-nodata" v-show="exerciseList.length == 0">
            <img src="../assets/nodata-03.png" alt="no-data" />
            <p>{{tips}}</p>
          </div>
          <practice-item ref="practiceItem" v-for="(item, index) in exerciseList" :key="index" :data="item"
            :index="index" v-model="item.userKey" practiceType="chapter" @on-check="changeProgress"
            :finish="progressInfo.finish"></practice-item>
        </div>
        <div class="fr practice-bar">
          <Affix :offset-top="160">
            <div class="practice-sheet">
              <h3 class="practice-sheet-header">答题卡</h3>
              <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
              <div class="practice-sheet-score" v-show="doResultVisible">
                <p>
                  正确率
                  <span class="right-rate">{{ rightPercent }}%</span>
                </p>
                <!-- <p>
                  <span class="wrong-num">{{ wrongExerciseNum }}</span>
                  道错题已加入错题本
                </p> -->
              </div>
              <div class="practice-sheet-list">
                <happy-scroll color="rgba(12, 154, 213 , 1)" size="5" resize hide-horizontal v-if="exerciseList.length > 0">
                  <!-- 排序答题卡 -->
                  <ul class="practice-sheet-serial clearfix" v-if="exerSortType == 2">
                    <li v-for="(item, index) in exerciseList" :key="index" :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }">
                      <a v-text="index + 1" @click="scrollPosition(index)"></a>
                    </li>
                  </ul>
                  <!-- 分类答题卡 -->
                  <ul class="practice-sheet-serial clearfix" v-if="exerSortType == 1">
                    <div v-if="singleFlag == true">单选题</div>
                    <li v-for="(item, index) in exerciseList" :key="index" :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }" v-if="singleFlag == true && item.type_id == 1">
                      <a v-text="index + 1" @click="scrollPosition(index)"></a>
                    </li>

                    <div v-if="multipleFlag == true">多选题</div>
                    <li v-for="(item, index) in exerciseList" :key="index" :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }" v-if="multipleFlag == true && item.type_id == 2">
                      <a v-text="index + 1" @click="scrollPosition(index)"></a>
                    </li>

                    <div v-if="subjectiveFlag == true">材料题</div>
                    <li v-for="(item, index) in exerciseList" :key="index" :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }" v-if="subjectiveFlag == true && item.type_id == 3">
                      <a v-text="index + 1" @click="scrollPosition(index)"></a>
                    </li>
                  </ul>
                </happy-scroll>
              </div>

              <div class="practice-sheet-button" v-show="!doResultVisible">
                <Button type="warning" long @click="postPractice">提交验证</Button>
              </div>
              <!-- <div class="practice-sheet-button" v-show="!doResultVisible">
                <Button type="primary" long @click="savePractice">保存进度</Button>
              </div> -->
              <div class="practice-sheet-button" v-show="doResultVisible">
                <Button type="primary" long @click="resetDoResult">重做一遍</Button>
              </div>
              <div class="practice-sheet-footer"> 
                <span>
					
                 <i class="ivu-icon ivu-icon-record"></i> 正确
                </span>
                <span>
                  <Icon type="stop"></Icon> 错误
                </span>
                <span>
                  <Icon type="stop"></Icon> 未做
                </span>
              </div>
            </div>
          </Affix>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import { getQuestionList, getCategoryInfo, getQuestionTypeInfo } from "../api/api";
  import Header from '../components/header.vue'
  import PracticeItem from "../components/exercise/PracticeItem";
  import {
    HappyScroll,
	 
  } from "vue-happy-scroll";
  import "vue-happy-scroll/docs/happy-scroll.css";
  export default {
    name: 'Paper',
    // mixins: [siteMixin],
    data() {
      return {
        subId: 0,
        cId: 0,
        typeId : 0,
        exerciseList: [],
        finishExerciseNum: 0,
        categoryInfo: {}, // 课程详情
        questionType: {}, // 题目类型
        progressInfo: {}, // 课程分类详情
        prId: 0,
        wrongExerciseNum: 0,
        doResultVisible: false,
        exerSortType: 1, //答题排序
        singleFlag: false, //答题卡单选
        multipleFlag: false, //答题卡多选
        subjectiveFlag: false, //答题卡主观
        tips: '加载中......'
      };
    },
    computed: {
      progressPercent() {
        const totalNum = this.exerciseList.length;
        if (totalNum <= 0) return 0;
        let percent = (this.finishExerciseNum / totalNum) * 100;
        return Number(percent.toFixed(0));
      },
      lastRightPercent() {
        const totalNum = this.exerciseList.length;
        if (totalNum <= 0 || !this.progressInfo.correctExerNum) return 0;
        let percent = (this.progressInfo.correctExerNum / totalNum) * 100;
        return Number(percent.toFixed(0));
      },
      rightPercent() {
        const totalNum = this.exerciseList.length;
        if (totalNum <= 0) return 0;
        let rightNum = totalNum - this.wrongExerciseNum;
        let percent = (rightNum / totalNum) * 100;
        return Number(percent.toFixed(0));
      },
    },
    mounted() {
      //获取参数
      if (!this.initParams()) return;
      this.getBankCategory();
      this.getQuestionType();
      this.getQuestionList();
      this.getExerciseProgress();
    },
    methods: {
      initParams() {
        let subId = this.$route.params.id;
        let cId = this.$route.query.cid;
        let typeId = this.$route.query.type_id;
        this.subId = subId;
        this.cId = cId;
        this.typeId = typeId;
        return true;
      },
      getBankCategory() {
        getCategoryInfo({id: this.cId}).then((res) => {
          if (res.code === 1) {
            this.categoryInfo = res.data;
          }
        });
      },
      getQuestionType() {
        getQuestionTypeInfo({id: this.typeId}).then((res) => {
          if(res.code == 1) {
            this.questionType = res.data
          }
        })
      },
      getQuestionList() {
        getQuestionList({subjectId: this.subId}).then((res) => {
          if (res.code === 1) {
            this.progressInfo = res.data.subject;
            // this.exerSortType = this.progressInfo.ExerSortType;
            // const lastPosition = this.progressInfo.lastPosition;
            // this.finishExerciseNum = lastPosition > 0 ? lastPosition : 0;
            this.getExerciseList(res.data.list);
          }
        });
      },
      getExerciseProgress() {
        // study.getPracticeProgress(this.umcId, this.catalogId).then((res) => {
        //   //console.log(res);
        //   if (res.status === 1) {
        //     this.progressInfo = res.data;
        //     this.exerSortType = this.progressInfo.ExerSortType;
        //     //this.finishExerciseNum = this.progressInfo.finishExerNum;
        //     const lastPosition = this.progressInfo.lastPosition;
        //     this.finishExerciseNum = lastPosition > 0 ? lastPosition : 0;
        //     this.getExerciseList();
        //   }
        // });
      },
      getExerciseList(list) {
        // if (this.exerciseList.length > 0) {
        //   this.prId = this.exerciseList[0].prId;
        // }
        //学习进度及做题是否正确
        list.forEach((item, index) => {
          if (item.type_id == 1) {
            this.$set(item, "keyType", "单选");
            if(!this.singleFlag){
              this.singleFlag = true;
            }
          }
          if (item.type_id == 2) {
            this.$set(item, "keyType", "多选");
            if(!this.multipleFlag){
              this.multipleFlag = true;
            }
          }
          if (item.type_id == 3) {
            this.$set(item, "keyType", "材料");
            if(!this.subjectiveFlag){
              this.subjectiveFlag = true;
            }
          }
          if (this.finishExerciseNum <= index || item.userKey == "") {
            // item.starCount = 0;
            // item.userKey = "";
            // item.userKeyImg1 = item.userKeyImg2 = item.userKeyImg3 = "";
            this.$set(item, "starCount", 0);
            this.$set(item, "userKey", '');
            this.$set(item, "userKeyImg1", '');
            this.$set(item, "userKeyImg2", '');
            this.$set(item, "userKeyImg3", '');
            this.$set(item, "doResult", 0);
          } else {
            if (this.getAnswerIsRight(item)) {
              this.$set(item, "doResult", 1);
            } else {
              this.$set(item, "doResult", -1);
            }
          }
        });

        this.$nextTick(function() {
          this.exerciseList = list;
          this.tips = "老师正在抓紧制作中...... 敬请期待！";
        });

      },
      changeProgress(item) {
        this.finishExerciseNum++;
        // 错题加入错题本
      },
      scrollPosition: function(i) {
        var top = document.querySelectorAll(".practice-item")[i].offsetTop - 162;
        window.scroll({
          top: top,
          left: 0,
          behavior: "smooth"
        });
      },
      pageRunTime() {
        this.runSecond = 0;
        setInterval(() => {
          this.runSecond++;
        }, 1000);
      },
      getAnswerIsRight(item) {
        if (this.keyType(item) === 1) {
          if (item.userKey.trim() == item.correct_option.trim()) return true;
          else return false;
        } else {
          if (item.starCount > 3) return true;
          else return false;
        }
      },
      keyType(item) {
        if (
          item.type_id == "1" ||
          itema.type_id == "2"
        ) {
          return 1; //客观题
        } else {
          return 2; //主观题
        }
      },
      savePractice() {
        console.log('save')
        let lastPosition = 0;
        let ueIdSet = "";
        let userKeySet = "";
        let imageSet = "";
        this.exerciseList.forEach((item, index) => {
          if (item.userKey != "" || item.userKeyImg1) {
            if (ueIdSet) ueIdSet += "|";
            if (userKeySet) userKeySet += "|";
            if (imageSet) imageSet += "|";
            ueIdSet += item.id;
            lastPosition = index + 1;
            //答案处理
            if (item.userKey != "") {
              userKeySet += item.userKey;
            } else {
              userKeySet += "-";
            }

            //主观题答案图片
            if (item.userKeyImg1) {
              imageSet += item.userKeyImg1;
              if (item.userKeyImg2) {
                imageSet += `,${item.userKeyImg2}`;
              }
              if (item.userKeyImg3) {
                imageSet += `,${item.userKeyImg3}`;
              }
            } else {
              imageSet += "-";
            }
          }
        });
        if (userKeySet == "") {
          this.$Message.info("还没有做题，无法保存");
          return;
        }
        userKeySet = userKeySet.replace(/-/g, "");
        imageSet = imageSet.replace(/-/g, "");
        let data = {
          prid: this.prId,
          time: this.runSecond,
          lastposition: lastPosition,
          ueidset: ueIdSet,
          userkeyset: userKeySet,
          userKeyImgset: imageSet,
        };
        this.$Spin.show();
        // study.savePractice(data).then((res) => {
        //   //console.log(res);
        //   if (res.status === 1) {
        //     this.$Message.success("进度保存成功");
        //     setTimeout(() => {
        //       // this.$router.push({
        //       //   name: "CourseStudy",
        //       //   params: { cid: this.courseId },
        //       // });
        //       this.reloadPage();
        //     }, 1500);
        //   } else {
        //     this.$Message.error("进度保存失败");
        //   }
        //   this.$Spin.hide();
        // });
      },
      postPractice() {
        //检查答案
        this.$refs.practiceItem.forEach((item) => {
          item.checkAnswer();
        });
        let ueIdSet = "";
        let userKeySet = "";
        let starSet = "";
        let resultSet = "";
        let imageSet = "";
        this.exerciseList.forEach((item, index) => {
          // if (ueIdSet) ueIdSet += "|";
          // if (userKeySet || index == 1) userKeySet += "|";
          // if (starSet) starSet += "|";
          // if (resultSet) resultSet += "|";
          // if (imageSet || index == 1) imageSet += "|";
          // ueIdSet += item.id;
          // userKeySet += item.userKey;
          // starSet += item.starCount;
          if (item.doResult == 1) {
            resultSet += "1";
          } else {
            this.wrongExerciseNum++;
            resultSet += "0";
          }
          // if (item.userKeyImg1) {
          //   imageSet += item.userKeyImg1;
          //   if (item.userKeyImg2) {
          //     imageSet += `,${item.userKeyImg2}`;
          //   }
          //   if (item.userKeyImg3) {
          //     imageSet += `,${item.userKeyImg3}`;
          //   }
          // }
        });
        // if (userKeySet == "") {
        //   this.$Message.info("还没有做题，无法提交");
        //   return;
        // }
        this.doResultVisible = true;
        // let data = {
        //   umcid: this.umcId,
        //   catid: this.catalogId,
        //   prid: this.prId,
        //   ueidset: ueIdSet,
        //   userkeyset: userKeySet,
        //   starcounts: starSet,
        //   resultset: resultSet,
        //   courseId: this.courseId,
        //   userKeyImgset: imageSet,
        // };
        // this.$Spin.show();
        // study.postPractice(data).then((res) => {
        //   //console.log(res);
        //   if (res.status === 1) {
        //     this.doResultVisible = true;
        //   } else {
        //     this.$Message.error("提交失败");
        //   }
        //   this.$Spin.hide();
        // });
      },
      resetDoResult() {
        this.reloadPage();
        //this.exerciseList = [];
      },
      reloadPage() {
        window.location.reload();
      },
    },
    components: {
      Header,
      PracticeItem,
      HappyScroll
    },
  };
</script>

<style lang="less" scoped>
  // @import "../../assets/css/var";
  @import "../assets/css/exercise.css";
  .breadcrumb {
    padding: 10px 0;

    .home {
      vertical-align: -0.5px;
      margin-right: 2px;
    }
  }

  .practice-nodata {
    padding: 35px;
    text-align: center;

    img {
      margin: 0 auto;
    }

    p {
      margin-top: 16px;
      text-align: center;
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/paper.vue